export enum POST_PUBLISHING_DIALOG_MODE {
    publishing = 'publishing',
    access = 'access',
}
